// This file is automatically updated on release
export const releaseDate = new Date('Tue 14 May 2024 02:46:00 PM UTC');
